export default "/apps/maps/img/fa-solid-900.svg";